import { defineStore } from 'pinia'

interface FirstTimeDate {
  day: number;
  month: number;
  year: number;
}

interface Count {
  count: number;
  first_time_date: FirstTimeDate;
  day: number;
  month: number;
  year: number;
  has_showed: string; // Pode ser 'true' ou 'false', mas está definido como string
  last_page: string;
}

export const subscribeExitStore = defineStore('susbcribeExit', {
  state: () => ({
    bellaSubscribeExit: {} as Count
  }),
  actions: {
    async setSubscribeParams(payload: Count) {
      this.bellaSubscribeExit = payload
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'bellaSubscribeExit',
        storage: localStorage,
      },
    ],
  }
})
